import { createFileRoute } from '@tanstack/react-router'
import { QuestionBankPage } from '@/features/jobs/components/question-bank-page'

export const Route = createFileRoute(
  '/_app/_auth/dashboard/_layout/question-bank',
)({
  component: QuestionBankPage,
  beforeLoad: () => ({
    title: 'Question Bank',
    headerTitleKey: 'header.questionBank.title',
    headerDescriptionKey: 'header.questionBank.description',
  }),
})
